import { useTranslation } from 'react-i18next';

import { SmetterModuleSwitcher } from '@crm/features';
import { addMenuData } from '@crm/widgets/app-menu/model/app-menu-data';
import { MenuLink } from '@crm/widgets/app-menu/ui/MenuLink';

export const AppMenu = () => {
    const { t } = useTranslation();

    return (
        <nav className="flex h-full shrink-0 flex-col items-start justify-start gap-6 self-stretch border-r border-gray-200 bg-white pt-1.5">
            <div className="flex w-full flex-col px-3">
                <SmetterModuleSwitcher source="crm" />
            </div>

            <ul className="flex min-h-0 flex-1 flex-col items-center gap-6 overflow-x-hidden overflow-y-auto px-4">
                {addMenuData.map((menuItem) => (
                    <MenuLink
                        key={menuItem.route}
                        textContent={t(menuItem.menuTextKey)}
                        toHref={menuItem.route}
                        icon={menuItem.icon}
                    />
                ))}
            </ul>
        </nav>
    );
};
